export const USER_GROUPS: Record<string, string> = {
  DEFAULT: '默认分组',
  CHINA_IMPORT: '中国进口'
};

export const CURRENCY_SIGNS: Record<string, string> = {
  USD: '$',
  RMB: '￥'
};

export const LABEL_USER_OPERATIONS = {
  PROFILE: '用户信息',
  CARRIERS: '物流设置',
  BILL: '账单信息'
};

export const WAREHOUSE_DETAIL_OOPERATIONS = {
  INVENTROY: '库存管理',
  VENDORS: '供应商管理',
  ORDERS: '订单管理',
  USERS: '用户管理',
  CARRIERS: '物流设置'
};

export const HWC_CLIENT_OPERATIONS = {
  USERS: '用户管理',
  WAREHOUSES: '仓库授权',
  PRODUCTS: '商品管理',
  TOU_CHENG: '头程订单',
  FULFILL: '发货订单',
  STOCK: '库存管理',
  BILLS: '账单管理',
  CARRIERS: '物流渠道',
  APIKEYS: 'API密钥',
  OPERATIONS: '操作日志'
};

export const HWC_CLIENT_WAREHOUSE_OPERATIONS = {
  OPERATIONAL_FEES: '仓库操作费',
  MABANG_ERP: '马帮ERP授权'
};

export const HWC_BILL_TYPES = {
  DELIVER: '代发订单',
  STORAGE: '仓储费',
  TOP_UP: '充值'
};

export const HWC_PARTNER_OPERATIONS = {
  WAREHOUSE: '仓库管理'
};

export const HWC_WAREHOUSES_OPERATIONS = {
  ERP: 'ERP 管理',
  CARRIERS: '物流渠道',
  STOCKS: '库存同步',
  ORDERS: '订单同步'
};

export const getShippingStatus = (status: string): string => {
  switch (status) {
    case '1':
      return '待确认';
    case '2':
      return '待发货';
    case '3':
      return '已打包';
    case '4':
      return '已发货';
    case '5':
      return '审核不通过';
    case '6':
      return '已签收';
    case '0':
      return '草稿箱';
    case '9':
      return '错误';
    default:
      return '未知';
  }
};

export const getFulfillOrderDeleteStatus = (status: string): string => {
  switch (status) {
    case '0':
      return '正常';
    case '1':
      return '待删除';
    case '2':
      return '已删除';
    default:
      return '未知';
  }
};
